import React from "react";
import styled, { withTheme } from "styled-components";
import { ButtonTxtStyle } from "storybook-components/Typography";
const StyledDiv = styled.div`
  .mktoForm .mktoButtonRow {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .mktoForm .mktoButtonRow button.mktoButton {
    ${ButtonTxtStyle};
    width: auto;
    height: 48px;
    padding: 0 40px !important;
    border-radius: 10px !important;
    border: none;
    color: ${({ theme }) => theme.colors.green5} !important;
    background-color: ${({ theme }) => theme.colors.green2} !important;
    background-image: none;
    ${({ theme }) => theme.media.desktopDown`
      width: 100% !important;
    `};
    ${({ theme }) => theme.media.desktopUp`
      width: auto !important;
    `};
    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.colors.green3} !important;
      border: none !important;
    }
    &:active {
      background: ${({ theme }) => theme.colors.green4} !important;
      border: none !important;
    }
  }
`;

const MarketoButtonStyle = ({ children }) => <StyledDiv>{children}</StyledDiv>;

export default withTheme(MarketoButtonStyle);
